import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockReasonSelectorComponent } from './block-reason-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [BlockReasonSelectorComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
  ],
  exports: [BlockReasonSelectorComponent],
})
export class BlockReasonsSelectorModule {}
